import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TaskStep } from 'app-models';

@Component({
  selector: 'app-vd-builder-preview-steps',
  templateUrl: './vd-builder-preview-steps.component.html',
  styleUrls: ['./vd-builder-preview-steps.component.scss']
})
export class VdBuilderPreviewStepsComponent implements OnInit {

  @Input()
  inputStepList: any[];

  userType: string;
  stepList: TaskStep[]; // Holding step list passed by pa rent

  constructor() {
    this.stepList = [];
  }

  ngOnInit(): void { }

  ngOnChanges(e: SimpleChanges) {
    if (e.inputStepList && e.inputStepList.currentValue) {
      this.stepList = e.inputStepList.currentValue;
      console.log(this.stepList);
    }
  }

}
